import React from 'react';
import { Spin } from 'antd';

const SpinCenter = ({ size = 'default' }) => (
    <div className="p-t-20 text-center">
        <Spin size={size} />
    </div>
);

export default SpinCenter;
